var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehiculeGreenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.8,
    height: 45.5,
    viewBox: "0 0 40.8 45.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_453",
    x: 4.35,
    y: 20.473,
    width: 15.65,
    height: 16.927,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_454",
    x: 20.794,
    y: 20.471,
    width: 15.659,
    height: 16.889,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_455",
    x: 11.55,
    y: 23.4,
    width: 17.7,
    height: 14.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_456",
    x: 11.55,
    y: 25.45,
    width: 17.7,
    height: 14.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_457",
    x: 0,
    y: 0,
    width: 40.8,
    height: 45.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_459",
    x: 17.667,
    y: 3.917,
    width: 17.637,
    height: 21.083,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_335",
    "data-name": "Groupe 335",
    transform: "translate(5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5, -0.5)",
    filter: "url(#Trac\\xE9_453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_453-2",
    "data-name": "Trac\\xE9 453",
    d: "M-8.7,131.4l-2.7-.6a1.154,1.154,0,0,0-1.4,1.15v1.15c0,.9.7,1.05,1.55,1.1h3.1c.55,0,1-.2,1-.75v-.15a1.982,1.982,0,0,0-1.55-1.9Zm-3.15,1.75V131.9c0-.15.1-.25.25-.2l2.75.6a1.015,1.015,0,0,1,.75.85c-.1.05-3.7.05-3.75,0Zm0,0",
    transform: "translate(22.15 -109.8)",
    fill: "#54b9a3",
    stroke: "#54b9a3",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5, -0.5)",
    filter: "url(#Trac\\xE9_454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_454-2",
    "data-name": "Trac\\xE9 454",
    d: "M188.8,130.8l-2.75.6a1.873,1.873,0,0,0-1.5,1.85.735.735,0,0,0,.6.85c.35.1,2.6.05,3.55.05.85,0,1.5-.2,1.5-1.1V131.9a1.126,1.126,0,0,0-1.4-1.1Zm.45,2.35c-.15.05-3.65.05-3.7.05a.962.962,0,0,1,.7-.85l2.75-.6c.15-.05.25.05.25.2Zm0,0",
    transform: "translate(-158.75 -109.8)",
    fill: "#54b9a3",
    stroke: "#54b9a3",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5, -0.5)",
    filter: "url(#Trac\\xE9_455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_455-2",
    "data-name": "Trac\\xE9 455",
    d: "M80.8,165.871H74.1a.5.5,0,0,0-.5.5.472.472,0,0,0,.5.5h6.7a.5.5,0,0,0,.5-.5.472.472,0,0,0-.5-.5Zm0,0",
    transform: "translate(-57.05 -141.97)",
    fill: "#54b9a3",
    stroke: "#54b9a3",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5, -0.5)",
    filter: "url(#Trac\\xE9_456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_456-2",
    "data-name": "Trac\\xE9 456",
    d: "M80.8,190.468H74.1a.5.5,0,0,0-.5.5.472.472,0,0,0,.5.5h6.7a.5.5,0,0,0,.5-.5.472.472,0,0,0-.5-.5Zm0,0",
    transform: "translate(-57.05 -164.52)",
    fill: "#54b9a3",
    stroke: "#54b9a3",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5, -0.5)",
    filter: "url(#Trac\\xE9_457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_457-2",
    "data-name": "Trac\\xE9 457",
    d: "M-35.6-99.83h-.9a2.407,2.407,0,0,0-2.1,1.15l-.9-1.8a7.528,7.528,0,0,0,4.4-6.85,7.661,7.661,0,0,0-7.6-7.6,7.576,7.576,0,0,0-7.55,7.55,7.2,7.2,0,0,0,.45,2.55h-6.05a2.78,2.78,0,0,0-2.6,1.75l-2.1,4.35a2.522,2.522,0,0,0-2.1-1.15h-.95a1.431,1.431,0,0,0-1.4,1.4v.6a1.4,1.4,0,0,0,1.4,1.4h1.45a4.287,4.287,0,0,0-.9,2.7v3.2a5.263,5.263,0,0,0,1.3,3.4v2.4a1.846,1.846,0,0,0,1.85,1.85h2a1.846,1.846,0,0,0,1.85-1.85v-.95H-43.2v.95a1.846,1.846,0,0,0,1.85,1.85h2a1.845,1.845,0,0,0,1.85-1.85v-2.4a4.946,4.946,0,0,0,1.3-3.35v-3.2a4.492,4.492,0,0,0-.4-1.8,4.361,4.361,0,0,0-.55-.9h1.55a1.4,1.4,0,0,0,1.4-1.4v-.6a1.43,1.43,0,0,0-1.4-1.4Zm-7.1-14.1a6.583,6.583,0,0,1,6.6,6.55,6.572,6.572,0,0,1-6.55,6.55,6.572,6.572,0,0,1-6.55-6.55,6.53,6.53,0,0,1,6.5-6.55Zm-14.85,11.25a1.794,1.794,0,0,1,1.7-1.15h6.5a7.448,7.448,0,0,0,6.65,4,6.635,6.635,0,0,0,2.25-.35c.05.05,1.25,2.6,1.45,2.95H-60.25c.2-.3-.1.4,2.7-5.45ZM-64-97.88v-.6a.441.441,0,0,1,.4-.45h.9a1.847,1.847,0,0,1,1.6,1.15c-.05.1-.15.2-.2.3h-2.3a.394.394,0,0,1-.4-.4Zm7,13.05a.9.9,0,0,1-.9.9h-2a.9.9,0,0,1-.9-.9v-1.6a4.1,4.1,0,0,0,2.15.6H-57Zm17.7.9h-2a.9.9,0,0,1-.9-.9v-.95h1.65a4.108,4.108,0,0,0,2.15-.6v1.6a.887.887,0,0,1-.9.85Zm2.2-6.7a3.682,3.682,0,0,1-3.45,3.85h-18.1a3.715,3.715,0,0,1-3.45-3.85v-3.2a3.33,3.33,0,0,1,1.05-2.45H-38.1a4,4,0,0,1,.75,1.05,3.534,3.534,0,0,1,.3,1.4v3.2Zm1.9-7.25a.394.394,0,0,1-.4.4h-2.3a1.049,1.049,0,0,1-.2-.3c.15-.15.5-1.15,1.6-1.15h.9a.394.394,0,0,1,.4.4Zm0,0",
    transform: "translate(70 115.43)",
    fill: "#54b9a3",
    stroke: "#54b9a3",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5, -0.5)",
    filter: "url(#Trac\\xE9_459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_459-2",
    "data-name": "Trac\\xE9 459",
    d: "M148.7-65.56a3.8,3.8,0,0,1,3.516-2.37,3.772,3.772,0,0,1,2.167.681.474.474,0,0,1,.118.66.474.474,0,0,1-.66.117,2.831,2.831,0,0,0-1.625-.51,2.844,2.844,0,0,0-2.463,1.422h2.463a.474.474,0,0,1,.474.474.474.474,0,0,1-.474.474h-2.8a2.835,2.835,0,0,0-.039.474,2.836,2.836,0,0,0,.039.474h2.8a.474.474,0,0,1,.474.474.474.474,0,0,1-.474.474H149.75a2.844,2.844,0,0,0,2.463,1.422,2.831,2.831,0,0,0,1.625-.51.474.474,0,0,1,.66.117.474.474,0,0,1-.118.66,3.772,3.772,0,0,1-2.167.681,3.8,3.8,0,0,1-3.516-2.37h-1.224A.474.474,0,0,1,147-63.19a.474.474,0,0,1,.474-.474h.977a3.819,3.819,0,0,1-.029-.474,3.817,3.817,0,0,1,.029-.474h-.977a.474.474,0,0,1-.474-.474.474.474,0,0,1,.474-.474Zm0,0",
    transform: "translate(-124.33 72.35)",
    fill: "#54b9a3",
    stroke: "#54b9a3",
    strokeWidth: 1,
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiculeGreenIcon);
export default __webpack_public_path__ + "static/media/vehicule-green-icon.b4feb9caa7a0f7cc12e45af0d002780e.svg";
export { ForwardRef as ReactComponent };